module.exports = require("object-assign");


//////////////////
// WEBPACK FOOTER
// external "object-assign"
// module id = 57
// module chunks = 0